export const stripUrlProtocol = (url: string): string =>
  url.replace(/https?:\/\//i, '')
